/**
 * Google Analytics event helpers.
 * Safely no-ops if gtag is not loaded (user declined analytics cookies).
 */

function fire(event: string, params?: Record<string, unknown>) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', event, params);
  }
}

/** User completed registration */
export function trackSignup(method = 'email') {
  fire('sign_up', { method });
}

/** User created a new book */
export function trackBookCreated() {
  fire('book_created');
}

/** User placed a print order */
export function trackOrderPlaced(value?: number, currency = 'USD') {
  fire('purchase', { value, currency });
}

/** User shared a book publicly */
export function trackBookShared() {
  fire('book_shared');
}
